import { useState } from 'react';
import Tabbar from '../../../../../components/shared/tabbar/tabbar';
import { TabbarOption } from '../../../../../components/shared/tabbar/types/tabbarProps';
import './automaticVerificationModal.scss';
import { AutomaticVerificationModalProps, OptionsForCards, TypeOfCard, TypeOfValidation } from './types/automaticVerificationModalProps';
import AutomaticVerificationSingleTab from './automaticVerificationSingleTab';
import { ReactComponent as ErrorIcon } from "../../../../../icons/error.svg";
import { ReactComponent as emergencyHome } from '../../../../../icons/emergency_home.svg';
import { ReactComponent as CheckCircle } from "../../../../../icons/check_circle.svg";
import { ConfigField, KrEndangeredAreaFormTypes, KrLandslideFormTypes, krFormTypes } from '../../../../../contexts/krFormContext';
import { poFormTypes } from '../../../../../contexts/poFormContext';
import { ObjectType, PatternType } from '../../../../../contexts/types/card';
import { createValidationKrForm, createValidationKrFormWarnings, createValidationPoForm, validationErrorsKrForm, validationErrorsKrFormWarnings, validationErrorsPoForm } from '../../../../../helpers/validation/validation';
import { Dictionary } from '../../../../../helpers/dictionariesFromLayers';

const AutomaticVerificationModal = (props: AutomaticVerificationModalProps) => {

    const IconType = (validationType: TypeOfValidation) => {
        if (validationType === TypeOfValidation.error) return ErrorIcon;
        if (validationType === TypeOfValidation.valid) return CheckCircle;
        if (validationType === TypeOfValidation.warning) return emergencyHome;
        return undefined;
    }

    const checkValidation = (card: KrLandslideFormTypes | KrEndangeredAreaFormTypes | poFormTypes, cardType: TypeOfCard, dictionariesForValidation?: Dictionary) => {
        if (cardType === TypeOfCard.landslide) {
            let landslideCard = card as KrLandslideFormTypes;
            const cardType = landslideCard.landslideAttributes?.wersja;
            const patternType = cardType ? cardType : PatternType.P2007;
            let config: ConfigField = {
                Validation: createValidationKrForm(landslideCard, ObjectType.KRO, patternType, dictionariesForValidation),
                ValidationWarnings: createValidationKrFormWarnings(landslideCard, ObjectType.KRO, patternType),
                check: true
            };
            landslideCard.config = config;

            landslideCard = validationErrorsKrForm(landslideCard, ObjectType.KRO, patternType, true, props.cards?.dictionariesForValidation);
            landslideCard = validationErrorsKrFormWarnings(landslideCard, ObjectType.KRO, patternType);

            return landslideCard;
        }
        if (cardType === TypeOfCard.endangeredArea) {
            let endangeredAreaCard = card as KrEndangeredAreaFormTypes;
            const cardType = endangeredAreaCard.endangeredAreaAttributes?.wersjA_KARTY;
            const patternType = cardType ? cardType : PatternType.P2007;
            let config: ConfigField = {
                Validation: createValidationKrForm(endangeredAreaCard, ObjectType.KRTZ, patternType, dictionariesForValidation),
                ValidationWarnings: createValidationKrFormWarnings(endangeredAreaCard, ObjectType.KRTZ, patternType),
                check: true
            };
            endangeredAreaCard.config = config;
            endangeredAreaCard = validationErrorsKrForm(endangeredAreaCard, ObjectType.KRTZ, patternType, true, props.cards?.dictionariesForValidation);
            endangeredAreaCard = validationErrorsKrFormWarnings(endangeredAreaCard, ObjectType.KRTZ, patternType);
            return endangeredAreaCard;
        }
        if (cardType === TypeOfCard.protocol) {
            let protocolCard = card as poFormTypes;
            var config: ConfigField = {
                Validation: createValidationPoForm(protocolCard),
                check: false
            };
            protocolCard.config = config;
            protocolCard = validationErrorsPoForm(protocolCard);
            return protocolCard;
        }
        return undefined;
    }
    var elements: OptionsForCards[] = []

    const onClickOption = (navigate: number) => {
        return (event: React.SyntheticEvent<HTMLLIElement>) => {
            event.currentTarget.className = "activeTab";
            setSelectedTab(navigate);
            setReload(!reload);
        }
    }

    const middleCheckAttributes = (card?: krFormTypes | poFormTypes) => {
        let keys = Object.keys(card?.config?.ValidationError!) as Array<string>;
        let isValid: boolean = true;
        keys.forEach((key) => {
            if (card?.config?.ValidationError![key] !== "" &&
                card?.config?.ValidationError![key] !== undefined && card?.config?.ValidationError![key] !== null) {
                    isValid = false;
            }
        })
        return isValid;
    }

    const prepareOptions = () => {
        var tabBarOptions: TabbarOption[] = [];
        if (props && props.cards) {
            if (props.cards.populateLandslideCardResponse && props.cards.populateLandslideCardResponse.length > 0) {
                for (let i = 0; i < props.cards.populateLandslideCardResponse.length; i++) {
                    let landslide = checkValidation(props.cards.populateLandslideCardResponse[i], TypeOfCard.landslide, props.cards.dictionariesForValidation);
                    let middleCheck = middleCheckAttributes(landslide);
                    elements.push(
                        {
                            name: props.cards.populateLandslideCardResponse[i].landslideAttributes?.numeR_IDENTYFIKACYJNY?.toString(),
                            validationType: landslide?.config?.isValid || middleCheck ? (landslide?.config?.isValidWarnings && middleCheck) ? 3 : 2 : 1,
                            card: landslide,
                            cardType: 1
                        },
                    )
                }
            }
            if (props.cards.populateEndangeredAreaCardResponse && props.cards.populateEndangeredAreaCardResponse.length > 0) {
                for (let i = 0; i < props.cards.populateEndangeredAreaCardResponse.length; i++) {
                    let endangeredArea = checkValidation(props.cards.populateEndangeredAreaCardResponse[i], TypeOfCard.endangeredArea);
                    let middleCheck = middleCheckAttributes(endangeredArea);
                    elements.push(
                        {
                            name: props.cards.populateEndangeredAreaCardResponse[i].endangeredAreaAttributes?.numeR_IDENTYFIKACYJNY?.toString(),
                            validationType: endangeredArea?.config?.isValid ? (endangeredArea?.config?.isValidWarnings && middleCheck) ? 3 : 2 : 1,
                            card: endangeredArea,
                            cardType: 2
                        },
                    )
                }
            }
            if (props.cards.populateProtocolFormResponse && props.cards.populateProtocolFormResponse.length > 0) {
                for (let i = 0; i < props.cards.populateProtocolFormResponse.length; i++) {
                    let protocol = checkValidation(props.cards.populateProtocolFormResponse[i], TypeOfCard.protocol);
                    //let middleCheck = middleCheckAttributes(protocol);
                    elements.push(
                        {
                            name: props.cards.populateProtocolFormResponse[i].protocolAttributes?.obiekT_NUMER_IDENTYFIKACYJNY?.toString(),
                            validationType: protocol?.config?.isValid ? 3 : 1,
                            card: protocol,
                            cardType: 3
                        },
                    )
                }
            }
            for (let j = 0; j < elements.length; j++) {
                tabBarOptions.push({
                    name: elements[j].name, additionalIcon: IconType(elements[j].validationType), onClick: onClickOption(j + 1), additionalIconStyle: {
                        fill: elements[j].validationType === 3 ? "green" : undefined
                    }
                })
            }
        }
        return tabBarOptions;
    }

    var Options: TabbarOption[] = prepareOptions();

    const [selectedTab, setSelectedTab] = useState(Options.length > 0 ? 1 : undefined);
    const [reload, setReload] = useState<boolean>(true);

    const renderView = (viewIndex: number | undefined) => {
        if (viewIndex !== undefined) {
            return <AutomaticVerificationSingleTab card={elements[viewIndex - 1].card} type={elements[viewIndex - 1].cardType} rows={props.rows} triggeredFromLocal={props.triggeredFromLocal} dictionariesForValidation={props.cards?.dictionariesForValidation}/>
        }
    }
    return (<>
        {reload ? <><Tabbar selected={selectedTab} options={Options}></Tabbar>{renderView(selectedTab)}</> :
            <><Tabbar selected={selectedTab} options={Options}></Tabbar><>{renderView(selectedTab)}</></>}
    </>)
}

export default AutomaticVerificationModal;